<template>
    <div class="top_window" v-if="base.show">
        <div class="box" :style="'width:'+width">
            <div class="title">{{base.title}}<i class="el-icon-close" v-if="close" @click="cancel"></i></div>
            <div class="content">
                <slot></slot>
            </div>
            <div class="btns" v-if="btn_show && btns.length>0">
                <el-button v-for="(item,index) in  btns" :key="index"  :type="index == 0?'danger':'normal'" :class="{'btn_default':index == 0}"
                    @click="btn(index)">{{item}}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props: {
            btns: {
                type: Array,
                default: function () {
                    return ["确定", "取消"]
                }
            },
            base: {
                type: Object,
                default: function () {
                    return {
                        title: '',
                        show: false
                    }
                }
            },
            width: {
                type: String,
                default: "500px"
            },
            btn_show: {
                type: Boolean,
                default: true
            },
            close:{
                type:Boolean,
                default:true
            }
        },
        watch: {
            base: {
                handler(newValue) {
                    if (newValue.show) {
                        this.$emit("init");
                    }
                },
                deep: true
            }
        },
        data() {
            return {}
        },
        methods: {
            btn(index) {
                //一般默认第一个按钮是确定，后面的按钮是取消
                if (index == 0) {
                    this.$emit(`sure`)
                } else {
                    this.base.show = false;
                    this.$emit(`btn${index}`)
                }
            },
            cancel() {
                this.base.show = false;
                this.$emit("cancel");
            }
        }
    }
</script>
<style lang="scss" scoped></style>